// extracted by mini-css-extract-plugin
export default {"container":"container-jDG9t6Ro","image":"image-G04AqkWa","pulse":"pulse-idIzJioE","body":"body-kGAN5hV1"};